import React from "react";
import bck from "./background.module.scss";
import LottiPlayer from "./LottiPlayer";
import ActionButton from "../common/button/ActionButton";
import typo from "../text/typography.module.scss";



function Background({ data }) {

  const { profile_image, profile_name, profile_position, profile_bio } = data;



  return (
    <div className={`${bck.tbx_profile_layout}`}>
      <div className={`${bck.tbx_profile_layout}`}>
        <div className={`${bck.tbx_profile_layout_images}`}>
          <LottiPlayer />
          <img
            className={`${bck.tbx_profile_img}`}
            src={`${process.env.REACT_APP_IMAGE_CDN}/${profile_image}`}
            alt=""
          />
        </div>
      </div>
      <div className={`${bck.tbx_profile_name}`}>
        <h1 className={`${typo.tbx_h1}`}>{profile_name}</h1>
        <p className={`${typo.tbx_p1}`}>{profile_position}</p>
      </div>
      <div className={`${bck.tbx_profile_bio_layout}`}>
        <p className={`${typo.tbx_p1}`}>{profile_bio}</p>
      </div>
       <div className={`${bck.tbx_profile_btn_layout}`}>
        {(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && <ActionButton data={data}/> }
      </div>
    </div>
  );
}

export default Background;

// VERSION 1.1 image tabclix only
// import React from 'react';
// import bck from "./background.module.scss";

// function Background({image}) {

//   return (
//     <div className={`${bck.tbx_bck_img}`}>
//       <img
//         crossorigin
//         className={`${bck.tbx_img}`}
//         src={`${process.env.REACT_APP_IMAGE_PATH}/${image}`}
//         loading="lazy"
//       />
//     </div>
//   );
// }

// export default Background
